"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateProductVariation = exports.manageProductVariations = exports.getVariationsList = exports.getVariations = exports.getVariationById = exports.deleteProductVariation = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const getVariations = params => (0, _request.default)({
  url: '/products-variations',
  method: 'get',
  params
});
exports.getVariations = getVariations;
const getVariationById = id => (0, _request.default)({
  url: `/products-variations/${id}`,
  method: 'get'
});
exports.getVariationById = getVariationById;
const manageProductVariations = data => (0, _request.default)({
  url: '/products-variations/manage',
  method: 'post',
  data
});
exports.manageProductVariations = manageProductVariations;
const updateProductVariation = (id, data) => (0, _request.default)({
  url: `/products-variations/${id}`,
  method: 'patch',
  data
});
exports.updateProductVariation = updateProductVariation;
const deleteProductVariation = id => (0, _request.default)({
  url: `/products-variations/${id}`,
  method: 'delete'
});
exports.deleteProductVariation = deleteProductVariation;
const getVariationsList = data => (0, _request.default)({
  url: '/products-variations/list',
  method: 'post',
  data
});
exports.getVariationsList = getVariationsList;